const COLOR_RATIO = 0.3;

/**
 * Returns the intensity of a color based on the level
 *
 * @param {number} level
 * @return {*}
 */
export const getColorIntensity = (level: number) => {
    const intensity = 1 - (level - 1) * COLOR_RATIO;
    return intensity < COLOR_RATIO ? COLOR_RATIO : intensity;
};
